var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('station-error-messages'),(
            _vm.user.role === 'super_admin' ||
                (_vm.user.user_permissions &&
                    _vm.user.user_permissions.station_messages &&
                    _vm.user.user_permissions.station_messages.includes(_vm.PermissionsConstants.CREATE))
        )?_c('create-station-message-card'):_vm._e(),_c('station-message-table')],1)}
var staticRenderFns = []

export { render, staticRenderFns }